// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PDFPreviewer{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.PDFPreviewer canvas{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.PDFPreviewer .results-loading,\r\n.PDFPreviewer .results-none{\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n.PDFPreviewer .results-loading .MuiCircularProgress-root{\r\n    margin-bottom: 10px;\r\n}", ""]);
// Exports
module.exports = exports;
